exports = module.exports = require("../../../../../deck/node_modules/.pnpm/css-loader@2.1.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".signalfx-query-pairs {\n  padding: 10px 10px 0;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n.signalfx-query-pairs .add-new {\n  margin-bottom: 10px;\n  margin-top: 5px;\n}\n", ""]);

